import { sortBy } from 'lodash-es';
import { useMemo } from 'react';

import { RunSchema } from '@/types/schema';

export function useGroupChildByParentId(
  childRuns: RunSchema[] | undefined,
  childRunsLoading: boolean
) {
  return useMemo(() => {
    if (childRunsLoading && !childRuns) {
      return undefined;
    }
    return groupChildByParentId(childRuns);
  }, [childRuns, childRunsLoading]);
}

export function groupChildByParentId(childRuns: RunSchema[] | undefined) {
  if (!childRuns) {
    return undefined;
  }
  return (
    childRuns.reduce((acc, x) => {
      const parentId = x.parent_run_id ?? x.parent_run_ids?.slice(-1)[0];
      if (parentId) {
        const siblings = acc[parentId] || [];
        siblings.push(x);
        acc[parentId] = sortBy(siblings, 'dotted_order');
      }
      return acc;
    }, {} as Record<string, RunSchema[]>) ?? {}
  );
}
